(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const setup = scope => scope.querySelectorAll('[data-canonical-motion]').forEach(video => {
    if (video.dataset.ready) return;
    video.dataset.ready = 'true';
    const button = video.parentElement.querySelector('[data-motion-toggle]');
    let manualPause = false;
    let visible = false;
    const load = () => {
      const source = video.querySelector('source');
      if (source.dataset.src) { source.src = source.dataset.src; delete source.dataset.src; video.load(); }
    };
    const play = () => { load(); video.play().catch(() => {}); };
    const sync = () => { button.textContent = video.paused ? '再生' : '一時停止'; button.setAttribute('aria-pressed', String(!video.paused)); };
    video.addEventListener('play', sync); video.addEventListener('pause', sync);
    button.addEventListener('click', () => { if (video.paused) { manualPause = false; play(); } else { manualPause = true; video.pause(); } });
    const update = () => { if (visible && !reduced.matches && !manualPause && !document.hidden) play(); else video.pause(); };
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
      update();
    }), { threshold: 0.1 });
    observer.observe(video);
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', update);
    sync();
  });
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
